module.exports = __webpack_public_path__ + "img/universal-dice.2d0f5457.png";